<div class="admin-dashboard-page">

  <!-- Dashboard Top Header Bar -->
  <header class="admin-topbar">
    <div class="container-wide topbar-inner">

      <div class="brand">
        <div class="brand-left">
          <img src="/Ambition_built_logo.png" alt="Ambition Built Executive Portal" class="admin-topbar-logo">
          <span class="badge-tag">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            EXECUTIVE PORTAL
          </span>
        </div>

        <div class="topbar-actions-mobile">
          <a routerLink="/" class="btn-outline-white-sm">WEBSITE &rarr;</a>
          <button (click)="logout()" class="btn-logout-sm">LOGOUT</button>
        </div>
      </div>

      <!-- Main Navigation Tabs Switcher -->
      <nav class="admin-tab-nav">
        <button (click)="setTab('projects')" [class.active]="activeTab() === 'projects'" class="tab-btn">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span>PROJECTS PORTFOLIO</span>
          <span class="count-badge">{{ projects().length }}</span>
        </button>

        <button (click)="setTab('users')" [class.active]="activeTab() === 'users'" class="tab-btn">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <span>ADMIN USER ACCESS</span>
          <span class="count-badge">{{ adminUsersList().length }}</span>
        </button>

        <button (click)="setTab('consultations')" [class.active]="activeTab() === 'consultations'" class="tab-btn">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
          <span>CONSULTATION INQUIRIES</span>
          <span class="count-badge highlight">{{ consultationList().length }}</span>
        </button>
      </nav>

      <div class="topbar-actions-desktop">
        <a routerLink="/" class="btn-outline-white-sm">VIEW WEBSITE</a>
        <button (click)="logout()" class="btn-logout">LOGOUT</button>
      </div>

    </div>
  </header>

  <!-- Dashboard Main Content Surface -->
  <main class="container-wide dashboard-body section-padding">

    <!-- KPI Overview Summary Cards -->
    <div class="kpi-summary-grid">
      <div class="kpi-card" (click)="setTab('projects')">
        <div class="kpi-icon gold">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          </svg>
        </div>
        <div class="kpi-info">
          <span class="kpi-lbl">PORTFOLIO PROJECTS</span>
          <span class="kpi-val">{{ projects().length }} Showcase Homes</span>
        </div>
      </div>

      <div class="kpi-card" (click)="setTab('users')">
        <div class="kpi-icon blue">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
          </svg>
        </div>
        <div class="kpi-info">
          <span class="kpi-lbl">ADMIN ACCESS</span>
          <span class="kpi-val">{{ adminUsersList().length }} Active Accounts</span>
        </div>
      </div>

      <div class="kpi-card highlight-kpi" (click)="setTab('consultations')">
        <div class="kpi-icon gold-dark">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </div>
        <div class="kpi-info">
          <span class="kpi-lbl">CLIENT CONSULTATIONS</span>
          <span class="kpi-val">{{ consultationList().length }} Lodged Inquiries</span>
        </div>
      </div>
    </div>

    <!-- TAB 1: PROJECTS PORTFOLIO -->
    @if (activeTab() === 'projects') {
    <div class="dashboard-header">
      <div>
        <h1 class="page-title font-serif">ARCHITECTURAL PROJECTS PORTFOLIO</h1>
        <p class="page-sub">Manage custom residence showcases, videos, and specifications.</p>
      </div>

      <button (click)="openCreateModal()" class="btn-gold">
        + ADD NEW PROJECT
      </button>
    </div>

    <!-- Desktop Projects Table Grid -->
    <div class="projects-table-card desktop-table-only">
      <table class="admin-table">
        <thead>
          <tr>
            <th>PROJECT</th>
            <th>CATEGORY</th>
            <th>LOCATION</th>
            <th>BUILD SPECS</th>
            <th>VIDEO FILM</th>
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          @for (p of projects(); track p.id) {
          <tr>
            <td class="proj-cell">
              <img [src]="transformUrl(p.image)" [alt]="p.title" (error)="onImgErr($event)" class="thumb">
              <div class="info">
                <div class="title">{{ p.title }}</div>
                <div class="sub">{{ p.suburb }}</div>
              </div>
            </td>
            <td>
              <span class="cat-badge">{{ p.categoryLabel }}</span>
            </td>
            <td>{{ p.location }}</td>
            <td>
              <div>{{ p.size }}</div>
              <div class="dur">{{ p.buildTime }}</div>
            </td>
            <td>
              @if (p.videoUrl) {
              <span class="has-video">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                HAS VIDEO
              </span>
              } @else {
              <span class="no-video">NO VIDEO</span>
              }
            </td>
            <td class="actions-cell">
              <button (click)="openEditModal(p)" class="action-btn edit">EDIT</button>
              <button (click)="confirmDelete(p)" class="action-btn delete">DELETE</button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Mobile Project Cards View -->
    <div class="project-cards-mobile">
      @for (p of projects(); track p.id) {
      <div class="admin-project-card-mobile">
        <div class="card-thumb-wrap">
          <img [src]="transformUrl(p.image)" [alt]="p.title" (error)="onImgErr($event)">
          <span class="cat-pill">{{ p.categoryLabel }}</span>
        </div>
        <div class="card-content">
          <h3 class="card-title font-serif">{{ p.title }}</h3>
          <p class="card-suburb">{{ p.suburb }} • {{ p.size }}</p>
          <div class="card-actions">
            <button (click)="openEditModal(p)" class="action-btn edit">EDIT</button>
            <button (click)="confirmDelete(p)" class="action-btn delete">DELETE</button>
          </div>
        </div>
      </div>
      }
    </div>
    }

    <!-- TAB 2: ADMIN USER ACCESS MANAGEMENT -->
    @if (activeTab() === 'users') {
    <div class="dashboard-header">
      <div>
        <h1 class="page-title font-serif">ADMIN USER ACCESS CONTROL</h1>
        <p class="page-sub">Create and manage authorized admin accounts for this portal.</p>
      </div>
    </div>

    <div class="users-management-grid">

      <!-- Create Admin User Form Card -->
      <div class="user-card-panel">
        <h3 class="panel-title font-serif">+ CREATE NEW ADMIN USER</h3>
        <p class="panel-sub">New admins can log in to manage projects and uploads.</p>

        @if (createUserSuccess()) {
        <div class="alert-success">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          {{ createUserSuccess() }}
        </div>
        }

        @if (createUserError()) {
        <div class="alert-error">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {{ createUserError() }}
        </div>
        }

        <form [formGroup]="userForm" (ngSubmit)="createAdminUser()" class="admin-user-form">
          <div class="form-group">
            <label>NEW ADMIN USERNAME *</label>
            <input type="text" formControlName="newUsername" placeholder="e.g. john_builder">
          </div>

          <div class="form-group">
            <label>NEW ADMIN PASSWORD *</label>
            <input type="password" formControlName="newPassword" placeholder="Minimum 6 characters">
          </div>

          <button type="submit" class="btn-gold btn-full">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="16" y1="11" x2="22" y2="11" />
            </svg>
            CREATE ADMIN USER
          </button>
        </form>
      </div>

      <!-- Registered Admin Users List Table -->
      <div class="user-card-panel">
        <h3 class="panel-title font-serif">REGISTERED ADMIN ACCOUNTS ({{ adminUsersList().length }})</h3>
        <p class="panel-sub">Users authorized to access the Admin Portal.</p>

        <div class="table-responsive-wrap">
          <table class="admin-table user-table">
            <thead>
              <tr>
                <th>USERNAME</th>
                <th>ROLE</th>
                <th>CREATED</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              @for (user of adminUsersList(); track user.id) {
              <tr>
                <td>
                  <div class="user-name-badge">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                    <strong>{{ user.username }}</strong>
                  </div>
                </td>
                <td>
                  <span class="role-badge">ADMINISTRATOR</span>
                </td>
                <td class="date-cell">{{ user.created_at || 'Active' }}</td>
                <td>
                  <button (click)="deleteAdminUser(user.id, user.username)" class="action-btn delete">
                    DELETE
                  </button>
                </td>
              </tr>
              } @empty {
              <tr>
                <td colspan="4" class="empty-cell">
                  Default Master Admin Active ('admin'). Additional created users will appear here.
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

    </div>
    }

    <!-- TAB 3: CLIENT CONSULTATION INQUIRIES -->
    @if (activeTab() === 'consultations') {
    <div class="dashboard-header">
      <div>
        <h1 class="page-title font-serif">CLIENT CONSULTATION INQUIRIES</h1>
        <p class="page-sub">Lodged consultation leads from website visitors (notified to rajakaranverma@gmail.com).</p>
      </div>
    </div>

    <!-- Desktop Table View -->
    <div class="projects-table-card desktop-table-only">
      <table class="admin-table">
        <thead>
          <tr>
            <th>REF CODE</th>
            <th>CLIENT NAME</th>
            <th>CONTACT DETAILS</th>
            <th>PROJECT & LOCATION</th>
            <th>ESTIMATED BUDGET</th>
            <th>PROJECT VISION / NOTES</th>
            <th>SUBMITTED</th>
          </tr>
        </thead>
        <tbody>
          @for (c of consultationList(); track c.id) {
          <tr>
            <td>
              <span class="role-badge">{{ c.reference_code }}</span>
            </td>
            <td>
              <div class="user-name-badge">
                <strong>{{ c.full_name }}</strong>
              </div>
            </td>
            <td>
              <div><a [href]="'mailto:' + c.email" class="link-lead">{{ c.email }}</a></div>
              <div><a [href]="'tel:' + c.phone" class="link-sub">{{ c.phone }}</a></div>
            </td>
            <td>
              <div><strong>{{ c.project_type }}</strong></div>
              <div class="dur">{{ c.suburb }}</div>
            </td>
            <td>
              <span class="cat-badge gold">{{ c.budget_range }}</span>
            </td>
            <td>
              <div class="table-notes-preview">{{ c.message || 'No additional notes' }}</div>
            </td>
            <td class="date-cell">{{ c.created_at }}</td>
          </tr>
          } @empty {
          <tr>
            <td colspan="7" class="empty-cell">
              No consultation inquiries received yet. Submissions will populate here automatically.
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Mobile Client Lead Cards View -->
    <div class="consultation-cards-mobile">
      @for (c of consultationList(); track c.id) {
      <div class="lead-card">
        <div class="lead-card-header">
          <span class="ref-badge">{{ c.reference_code }}</span>
          <span class="lead-date">{{ c.created_at }}</span>
        </div>

        <div class="lead-client-name font-serif">{{ c.full_name }}</div>

        <div class="lead-meta-row">
          <span class="type-pill">{{ c.project_type }}</span>
          <span class="budget-pill">{{ c.budget_range }}</span>
        </div>

        <div class="lead-location">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          <span>{{ c.suburb }}</span>
        </div>

        @if (c.message) {
        <div class="lead-notes-quote">
          "{{ c.message }}"
        </div>
        }

        <div class="lead-actions-row">
          <a [href]="'tel:' + c.phone" class="btn-lead-call">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            CALL CLIENT
          </a>
          <a [href]="'mailto:' + c.email" class="btn-lead-email">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            EMAIL CLIENT
          </a>
        </div>
      </div>
      } @empty {
      <div class="empty-card-lead">
        No consultation inquiries received yet. Submissions will populate here automatically.
      </div>
      }
    </div>
    }

  </main>

  <!-- Custom Delete Confirmation Modal -->
  @if (deletingProject(); as delProj) {
  <div class="delete-modal-backdrop" (click)="cancelDelete()">
    <div class="delete-modal-card" (click)="$event.stopPropagation()">
      <div class="warn-icon">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#EF4444" stroke-width="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>

      <h3 class="del-title">DELETE PROJECT?</h3>
      <p class="del-desc">Are you sure you want to delete <strong>"{{ delProj.title }}"</strong>? This action cannot be
        undone.</p>

      <div class="del-actions">
        <button (click)="cancelDelete()" class="btn-cancel">CANCEL</button>
        <button (click)="executeDelete()" class="btn-confirm-delete">CONFIRM DELETE</button>
      </div>
    </div>
  </div>
  }

  <!-- Create/Edit Project Modal Drawer -->
  @if (isEditing()) {
  <div class="modal-backdrop" (click)="closeModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">

      <div class="modal-header">
        <h2 class="title font-serif">{{ editingProjectId() ? 'EDIT ARCHITECTURAL PROJECT' : 'CREATE NEW PROJECT' }}</h2>
        <button (click)="closeModal()" class="close-btn">&times;</button>
      </div>

      <form [formGroup]="projectForm" (ngSubmit)="saveProject()" class="admin-form">

        <div class="form-grid">

          <div class="form-group">
            <label>PROJECT TITLE *</label>
            <input type="text" formControlName="title" placeholder="e.g. The Bellevue Residence">
          </div>

          <div class="form-group">
            <label>BUILD CATEGORY *</label>
            <select formControlName="category">
              <option value="custom">Custom Residence</option>
              <option value="rebuild">Knock Down & Rebuild</option>
              <option value="duplexDesigns">Duplex Designs</option>
            </select>
          </div>

          <div class="form-group">
            <label>FULL LOCATION *</label>
            <input type="text" formControlName="location" placeholder="e.g. Mosman, Sydney NSW">
          </div>

          <div class="form-group">
            <label>SUBURB *</label>
            <input type="text" formControlName="suburb" placeholder="e.g. Mosman">
          </div>

          <div class="form-group">
            <label>BUILD TIME *</label>
            <input type="text" formControlName="buildTime" placeholder="e.g. 12 Months">
          </div>

          <div class="form-group">
            <label>TOTAL FLOOR AREA *</label>
            <input type="text" formControlName="size" placeholder="e.g. 620 sqm">
          </div>

          <div class="form-group">
            <label>COMPLETION YEAR *</label>
            <input type="text" formControlName="completionYear" placeholder="e.g. 2024">
          </div>

          <div class="form-group">
            <label>ARCHITECT STUDIO *</label>
            <input type="text" formControlName="architect" placeholder="e.g. Ambition Built Architectural Studio">
          </div>

          <!-- Cover Image URL / File Uploader with Loading Spinner & Live Preview -->
          <div class="form-group full-width">
            <label>MAIN COVER IMAGE *</label>
            <div class="input-with-upload">
              <input type="text" formControlName="image" placeholder="Paste image URL or click CHOOSE FILE">
              <label class="btn-file-upload">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
                  <polyline points="12 11 12 17" />
                  <polyline points="9 14 12 11 15 14" />
                </svg>
                CHOOSE FILE
                <input type="file" accept="image/*" (change)="onCoverFileSelected($event)" hidden>
              </label>
            </div>

            @if (coverFileName()) {
            <div class="upload-success-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Cover Image Selected: {{ coverFileName() }}
            </div>
            }

            <!-- Loading Spinner while uploading cover -->
            @if (isCoverUploading()) {
            <div class="media-uploading-loader">
              <span class="spinner-gold"></span>
              <span>Processing Cover Image File...</span>
            </div>
            } @else if (projectForm.get('image')?.value; as coverImg) {
            <div class="media-preview-box">
              <span class="preview-title">MAIN COVER IMAGE PREVIEW</span>
              <div class="img-preview-wrap">
                <img [src]="transformUrl(coverImg)" (error)="onImgErr($event)" alt="Main Cover Preview">
              </div>
            </div>
            }
          </div>

          <!-- Video Tour URL / File Uploader with Loading Spinner & Live Preview -->
          <div class="form-group full-width">
            <label>CINEMATIC VIDEO TOUR (MP4 / MOV)</label>
            <div class="input-with-upload">
              <input type="text" formControlName="videoUrl" placeholder="Paste MP4 video URL or click CHOOSE VIDEO">
              <label class="btn-file-upload">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
                  <line x1="7" y1="2" x2="7" y2="22" />
                  <line x1="17" y1="2" x2="17" y2="22" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <line x1="2" y1="7" x2="7" y2="7" />
                  <line x1="2" y1="17" x2="7" y2="17" />
                  <line x1="17" y1="17" x2="22" y2="17" />
                  <line x1="17" y1="7" x2="22" y2="7" />
                </svg>
                CHOOSE VIDEO
                <input type="file" accept="video/*" (change)="onVideoFileSelected($event)" hidden>
              </label>
            </div>

            @if (videoFileName()) {
            <div class="upload-success-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Video File Attached: {{ videoFileName() }}
            </div>
            }

            <!-- Loading Spinner while uploading video -->
            @if (isVideoUploading()) {
            <div class="media-uploading-loader">
              <span class="spinner-gold"></span>
              <span>Processing Cinematic Video File...</span>
            </div>
            } @else if (projectForm.get('videoUrl')?.value; as videoSrc) {
            <div class="media-preview-box">
              <span class="preview-title">CINEMATIC VIDEO TOUR PREVIEW</span>
              <div class="video-preview-wrap">
                <video [src]="transformUrl(videoSrc)" controls preload="metadata" class="admin-preview-video"></video>
              </div>
            </div>
            }
          </div>

          <div class="form-group full-width">
            <label>SHORT CARD SUMMARY *</label>
            <textarea formControlName="description" rows="2"
              placeholder="Brief 2-sentence teaser summary..."></textarea>
          </div>

          <div class="form-group full-width">
            <label>FULL ARCHITECTURAL OVERVIEW STORY *</label>
            <textarea formControlName="fullOverview" rows="4"
              placeholder="Detailed architectural narrative..."></textarea>
          </div>

        </div>

        <!-- Key Features Tag Manager -->
        <div class="tags-manager-section">
          <label class="tag-section-title">KEY INCLUSIONS & AUTOMATIONS</label>
          <div class="tag-input-row">
            <input type="text" formControlName="newFeatureInput"
              placeholder="Add feature item (e.g. Sub-Zero Automation)">
            <button type="button" (click)="addFeature()" class="btn-add-tag">+ ADD</button>
          </div>

          <div class="tags-chips">
            @for (feat of featuresList(); track feat; let i = $index) {
            <span class="tag-chip">
              {{ feat }}
              <button type="button" (click)="removeFeature(i)">&times;</button>
            </span>
            }
          </div>
        </div>

        <!-- Materials Tag Manager -->
        <div class="tags-manager-section">
          <label class="tag-section-title">SIGNATURE MATERIALS PALETTE</label>
          <div class="tag-input-row">
            <input type="text" formControlName="newMaterialInput"
              placeholder="Add material item (e.g. Calacatta Marble)">
            <button type="button" (click)="addMaterial()" class="btn-add-tag">+ ADD</button>
          </div>

          <div class="tags-chips">
            @for (mat of materialsList(); track mat; let i = $index) {
            <span class="tag-chip">
              {{ mat }}
              <button type="button" (click)="removeMaterial(i)">&times;</button>
            </span>
            }
          </div>
        </div>

        <!-- Gallery Images Tag Manager -->
        <div class="tags-manager-section">
          <label class="tag-section-title">HIGH-RES GALLERY PHOTOS</label>
          <div class="tag-input-row">
            <input type="text" formControlName="newGalleryInput" placeholder="Paste image URL or click UPLOAD PHOTOS">
            <button type="button" (click)="addGalleryImage()" class="btn-add-tag">+ ADD LINK</button>
            <label class="btn-file-upload">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                <circle cx="12" cy="13" r="4" />
              </svg>
              UPLOAD PHOTOS
              <input type="file" accept="image/*" multiple (change)="onGalleryFileSelected($event)" hidden>
            </label>
          </div>

          @if (isGalleryUploading()) {
          <div class="media-uploading-loader">
            <span class="spinner-gold"></span>
            <span>Processing Gallery Photos...</span>
          </div>
          }

          <div class="gallery-previews">
            @for (img of galleryList(); track img; let i = $index) {
            <div class="gal-thumb">
              <img [src]="transformUrl(img)" (error)="onImgErr($event)" alt="Gallery preview">
              <button type="button" (click)="removeGalleryImage(i)" class="del-img-btn">&times;</button>
            </div>
            } @empty {
            <div class="empty-gallery-hint">No gallery photos added yet. Click <strong>UPLOAD PHOTOS</strong> or paste
              link above.</div>
            }
          </div>
        </div>

        <div class="form-actions">
          <button type="button" (click)="closeModal()" class="btn-cancel">CANCEL</button>
          <button type="submit" class="btn-gold">SAVE ARCHITECTURAL PROJECT</button>
        </div>

      </form>

    </div>
  </div>
  }

</div>